(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["prossimi-corsi"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ProssimiCorsiCarousel) {
      window.ProssimiCorsiCarousel.init();
      return;
    }

    const instances = new WeakMap();
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    let splidePromise = null;

    const carouselElements = (root = document) => {
      const elements = Array.from(root.querySelectorAll('[data-prossimi-corsi-carousel]'));

      if (root.matches && root.matches('[data-prossimi-corsi-carousel]')) {
        elements.unshift(root);
      }

      return elements;
    };

    const shouldMount = (element) => {
      if (desktopMedia.matches) return element.dataset.carouselDesktop === 'true';
      return element.dataset.carouselMobile === 'true';
    };

    const loadSplide = (element) => {
      if (window.Splide) return Promise.resolve(window.Splide);
      if (splidePromise) return splidePromise;

      const source = element.dataset.splideSrc;
      const absoluteSource = new URL(source, window.location.href).href;
      const existingScript = Array.from(document.scripts).find((script) => script.src === absoluteSource);
      const script = existingScript || document.createElement('script');

      splidePromise = new Promise((resolve, reject) => {
        script.addEventListener('load', () => resolve(window.Splide), { once: true });
        script.addEventListener('error', reject, { once: true });
      });

      if (!existingScript) {
        script.src = source;
        script.defer = true;
        document.head.appendChild(script);
      }

      return splidePromise;
    };

    const destroy = (element) => {
      const instance = instances.get(element);

      if (instance) {
        instance.destroy(true);
        instances.delete(element);
      }

      element.classList.remove('prossimi-corsi-block__carousel--active');
    };

    const mount = async (element) => {
      if (instances.has(element) || !shouldMount(element)) return;

      await loadSplide(element);

      if (!element.isConnected || !shouldMount(element) || instances.has(element)) return;

      const perPage = desktopMedia.matches ? Number(element.dataset.perPage) || 1 : 1;
      const instance = new window.Splide(element, {
        perPage,
        perMove: 1,
        gap: '1.25rem',
        arrows: true,
        pagination: true,
      });

      instance.mount();
      instances.set(element, instance);
      element.classList.add('prossimi-corsi-block__carousel--active');
    };

    const sync = (element) => {
      if (shouldMount(element)) {
        mount(element);
      } else {
        destroy(element);
      }
    };

    const init = (root = document) => carouselElements(root).forEach(sync);
    const destroyWithin = (root = document) => carouselElements(root).forEach(destroy);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    desktopMedia.addEventListener('change', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));

    window.ProssimiCorsiCarousel = { init, destroy: destroyWithin };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["prossimi-eventi"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ProssimiEventiCarousel) {
      window.ProssimiEventiCarousel.init();
      return;
    }

    const instances = new WeakMap();
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    let splidePromise = null;

    const carouselElements = (root = document) => {
      const elements = Array.from(root.querySelectorAll('[data-prossimi-eventi-carousel]'));

      if (root.matches && root.matches('[data-prossimi-eventi-carousel]')) {
        elements.unshift(root);
      }

      return elements;
    };

    const shouldMount = (element) => {
      if (desktopMedia.matches) return element.dataset.carouselDesktop === 'true';
      return element.dataset.carouselMobile === 'true';
    };

    const loadSplide = (element) => {
      if (window.Splide) return Promise.resolve(window.Splide);
      if (splidePromise) return splidePromise;

      const source = element.dataset.splideSrc;
      const absoluteSource = new URL(source, window.location.href).href;
      const existingScript = Array.from(document.scripts).find((script) => script.src === absoluteSource);
      const script = existingScript || document.createElement('script');

      splidePromise = new Promise((resolve, reject) => {
        script.addEventListener('load', () => resolve(window.Splide), { once: true });
        script.addEventListener('error', reject, { once: true });
      });

      if (!existingScript) {
        script.src = source;
        script.defer = true;
        document.head.appendChild(script);
      }

      return splidePromise;
    };

    const destroy = (element) => {
      const instance = instances.get(element);

      if (instance) {
        instance.destroy(true);
        instances.delete(element);
      }

      element.classList.remove('prossimi-eventi-block__carousel--active');
    };

    const mount = async (element) => {
      if (instances.has(element) || !shouldMount(element)) return;

      await loadSplide(element);

      if (!element.isConnected || !shouldMount(element) || instances.has(element)) return;

      const perPage = desktopMedia.matches ? Number(element.dataset.perPage) || 1 : 1;
      const instance = new window.Splide(element, {
        perPage,
        perMove: 1,
        gap: '1.25rem',
        arrows: true,
        pagination: true,
      });

      instance.mount();
      instances.set(element, instance);
      element.classList.add('prossimi-eventi-block__carousel--active');
    };

    const sync = (element) => {
      if (shouldMount(element)) {
        mount(element);
      } else {
        destroy(element);
      }
    };

    const init = (root = document) => carouselElements(root).forEach(sync);
    const destroyWithin = (root = document) => carouselElements(root).forEach(destroy);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    desktopMedia.addEventListener('change', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));

    window.ProssimiEventiCarousel = { init, destroy: destroyWithin };
  })();
  } catch(e) { console.error(e); }
})();

})();
